module.exports = __webpack_public_path__ + "img/24hrs.35569640.svg";